function cov_zsmy9lgdc() {
  var path = "/app/src/components/shadow-view/shadow-view.tsx";
  var hash = "ef7cd392b559f0aa7b1265ac19e3c4d73551a9f9";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/shadow-view/shadow-view.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 26
        },
        end: {
          line: 42,
          column: 1
        }
      },
      "1": {
        start: {
          line: 18,
          column: 38
        },
        end: {
          line: 18,
          column: 71
        }
      },
      "2": {
        start: {
          line: 19,
          column: 38
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "3": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 30,
          column: 3
        }
      },
      "4": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 29,
          column: 5
        }
      },
      "5": {
        start: {
          line: 26,
          column: 21
        },
        end: {
          line: 26,
          column: 59
        }
      },
      "6": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 56
        }
      },
      "7": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 28
        }
      },
      "8": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 41,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 13,
            column: 26
          },
          end: {
            line: 13,
            column: 27
          }
        },
        loc: {
          start: {
            line: 17,
            column: 13
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 24,
            column: 18
          },
          end: {
            line: 24,
            column: 19
          }
        },
        loc: {
          start: {
            line: 24,
            column: 51
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 24
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 25
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 8
          },
          end: {
            line: 25,
            column: 15
          }
        }, {
          start: {
            line: 25,
            column: 19
          },
          end: {
            line: 25,
            column: 38
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 41,
            column: 3
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 33,
            column: 4
          },
          end: {
            line: 38,
            column: 7
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 40,
            column: 12
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 34,
            column: 7
          },
          end: {
            line: 34,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 7
          },
          end: {
            line: 34,
            column: 18
          }
        }, {
          start: {
            line: 34,
            column: 22
          },
          end: {
            line: 34,
            column: 30
          }
        }],
        line: 34
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 9
          },
          end: {
            line: 36,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 9
          },
          end: {
            line: 36,
            column: 19
          }
        }, {
          start: {
            line: 36,
            column: 23
          },
          end: {
            line: 36,
            column: 64
          }
        }],
        line: 36
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ef7cd392b559f0aa7b1265ac19e3c4d73551a9f9"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_zsmy9lgdc = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_zsmy9lgdc();
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './styles.css';
import { attachStyles, isShadowDomAvailable } from './utils';
cov_zsmy9lgdc().s[0]++;
export var ShadowView = function ShadowView(_ref) {
  var shouldInheritFontFamily = _ref.shouldInheritFontFamily,
    shouldInheritColor = _ref.shouldInheritColor,
    children = _ref.children;
  cov_zsmy9lgdc().f[0]++;
  var _ref2 = (cov_zsmy9lgdc().s[1]++, useState(null)),
    _ref3 = _slicedToArray(_ref2, 2),
    shadowRoot = _ref3[0],
    setShadowRoot = _ref3[1];
  var recordOfInheritedProperties = (cov_zsmy9lgdc().s[2]++, {
    'font-family': shouldInheritFontFamily,
    color: shouldInheritColor
  });
  cov_zsmy9lgdc().s[3]++;
  var setRoot = function setRoot(element) {
    cov_zsmy9lgdc().f[1]++;
    cov_zsmy9lgdc().s[4]++;
    if ((cov_zsmy9lgdc().b[1][0]++, element) && (cov_zsmy9lgdc().b[1][1]++, !element.shadowRoot)) {
      cov_zsmy9lgdc().b[0][0]++;
      var shadow = (cov_zsmy9lgdc().s[5]++, element.attachShadow({
        mode: 'open'
      }));
      cov_zsmy9lgdc().s[6]++;
      attachStyles(shadow, recordOfInheritedProperties);
      cov_zsmy9lgdc().s[7]++;
      setShadowRoot(shadow);
    } else {
      cov_zsmy9lgdc().b[0][1]++;
    }
  };
  cov_zsmy9lgdc().s[8]++;
  return isShadowDomAvailable ? (cov_zsmy9lgdc().b[2][0]++, /*#__PURE__*/React.createElement(React.Fragment, null, (cov_zsmy9lgdc().b[3][0]++, !shadowRoot) && (cov_zsmy9lgdc().b[3][1]++, children), /*#__PURE__*/React.createElement("span", {
    ref: setRoot,
    className: styles.containerPortal
  }, (cov_zsmy9lgdc().b[4][0]++, shadowRoot) && (cov_zsmy9lgdc().b[4][1]++, /*#__PURE__*/createPortal(children, shadowRoot))))) : (cov_zsmy9lgdc().b[2][1]++, children);
};